/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import { FETCH_COURSE_SUCCESS, CHANGE_COURSE_ENDDATE } from '../_actions/coursedetails.actions';

export const INITIAL_STATE = {courseDetails:[], courseChangesDetails:{}};


export function courseDetailsReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_COURSE_SUCCESS: {
            return {...state, courseDetails:action.payload, courseChangesDetails:{}};
        }
        case CHANGE_COURSE_ENDDATE: {
            let copyOfCourses = state.courseDetails.map(course => { return { ...course }; });
            copyOfCourses[action.payload.index].endDate = action.payload.endDate;
            return { ...state, courseDetails: copyOfCourses, courseChangesDetails: { ...state.courseChangesDetails, [action.payload.courseId]: { endDate: action.payload.endDate } } };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/coursedetails.reducer.js